const base = process.env.NODE_ENV !== 'production' ? '' : 'https://api.redditinvestigator.com';

class ApiError extends Error {
    constructor(response) {
        super(response.statusText);
        this.response = response;
    }
}

export default {
    handleErrors(response) {
        if (!response.ok)
            throw response;
        return response;
    },
    login(user, pass) {
        return fetch(`${base}/login.php`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            body: JSON.stringify({user, pass})
        })
            .then(this.handleErrors)
            .then(r => r.json());
    }
}
